import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Career from './pages/Career';
import Services from './pages/Services';
import Solutions from './pages/Solutions';
import Contact from './pages/Contact';
import TracknTone from './pages/TracknTone';
import Header from './components/Header';
import Footer from './components/Footer';
import ExternalRedirect, { TRACKNTONE_LEGAL } from './components/ExternalRedirect';

/** All TracknTone legal paths on this host → trackntone.com (no local copy). */
const LEGAL_REDIRECTS = [
  { path: '/privacy', to: TRACKNTONE_LEGAL.privacy },
  { path: '/terms', to: TRACKNTONE_LEGAL.terms },
  { path: '/subscription', to: TRACKNTONE_LEGAL.subscription },
  { path: '/subscription-policy', to: TRACKNTONE_LEGAL.subscription },
  { path: '/delete-account', to: TRACKNTONE_LEGAL.deleteAccount },
  { path: '/trackntone/privacy', to: TRACKNTONE_LEGAL.privacy },
  { path: '/trackntone/terms', to: TRACKNTONE_LEGAL.terms },
  { path: '/trackntone/subscription', to: TRACKNTONE_LEGAL.subscription },
  { path: '/trackntone/subscription-policy', to: TRACKNTONE_LEGAL.subscription },
  { path: '/trackntone/delete-account', to: TRACKNTONE_LEGAL.deleteAccount },
];

function SiteChrome({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Legal: no Header/Footer — immediate redirect to trackntone.com */}
          {LEGAL_REDIRECTS.map(({ path, to }) => (
            <Route key={path} path={path} element={<ExternalRedirect to={to} />} />
          ))}

          <Route
            path="/"
            element={
              <SiteChrome>
                <Home />
              </SiteChrome>
            }
          />
          <Route
            path="/career"
            element={
              <SiteChrome>
                <Career />
              </SiteChrome>
            }
          />
          <Route
            path="/services"
            element={
              <SiteChrome>
                <Services />
              </SiteChrome>
            }
          />
          <Route
            path="/solutions"
            element={
              <SiteChrome>
                <Solutions />
              </SiteChrome>
            }
          />
          <Route
            path="/contact"
            element={
              <SiteChrome>
                <Contact />
              </SiteChrome>
            }
          />
          <Route
            path="/trackntone"
            element={
              <SiteChrome>
                <TracknTone />
              </SiteChrome>
            }
          />

          <Route
            path="*"
            element={
              <SiteChrome>
                <h1>404 - Page Not Found</h1>
              </SiteChrome>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
